{ avatarDomain } = require '@trello/config'
{ isDesktop } = require '@trello/browser'
{ currentModelManager } = require 'app/scripts/controller/currentModelManager'
EntityDisplay = require 'app/scripts/lib/entity-display'
Promise = require 'bluebird'
{ Storage } = require '@trello/storage'
_ = require 'underscore'
xtend = require 'xtend'
{ dontDismissNotifications } = require '@trello/config'

Notification = window.Notification ? { permission: 'denied' }

module.exports = class DesktopNotification
  # Amount of time to wait after writing lock to read it
  LOCK_DELAY = 100
  # Head start to give 'priority' windows (i.e. ones displaying the board/org
  # the notification is about)
  PRIORITY_DELAY = 1000
  # Amount of time to wait to clear the lock and notification
  CLEAR_DELAY = 10000

  @enabled: -> Notification.permission == 'granted'
  @denied: -> Notification.permission == 'denied'
  @notEnabled: -> Notification.permission == 'default'
  @requestPermission: ->
    new Promise (resolve, reject)->
      reqPerm = Notification.requestPermission
      if !reqPerm then reject('denied')
      else reqPerm (result) ->
        if result == 'denied' then reject(result)
        else resolve(result)

  constructor: (@model) ->
    if (!DesktopNotification.enabled() && !window.fluid) ||
        !@model.get('unread')
      return

    # If the board is open somewhere in a tab, we want to give that tab first
    # dibs on displaying the notification so that it can load in that tab if
    # clicked.
    if @localNotification()
      @show()
    else
      setTimeout(@show.bind(@), PRIORITY_DELAY)

  show: ->
    if @model.get('type') == 'reactionAdded'
      return

    @getLock =>
      { title, body, icon, tag } = @render()

      if window.fluid
        # If you're using Trello in Fluid, use Growl notifications
        window.fluid.showGrowlNotification({
          title
          priority: 1
          sticky: false
          description: body
          icon
        })
      else
        # Normal browser notifications
        n = new Notification(title, { body, icon, tag })
        n.model = @model
        n.addEventListener('click', @clickHandler.bind(@))

        if !dontDismissNotifications
          setTimeout =>
            n.close()
          , CLEAR_DELAY

  stringifyEntity = (entity) ->
    switch entity.type
      when 'relDate'
        entity.current
      when 'comment', 'attachmentPreview'
        ''
      else
        entity.text

  render: ->
    entities = new EntityDisplay('notification').getEntities(@model.getDisplay())

    title = _.chain entities
    .map stringifyEntity
    .compact()
    .value()
    .join('')
    .trim()

    commentEntity = _.find(entities, (e) -> e.type == 'comment')
    body = if commentEntity? then commentEntity.text else ''

    member = @model.getMember()
    icon = '/favicon.ico'
    if member?.avatarHash
      icon = [avatarDomain, member.avatarHash, '50.png'].join('/')

    tag = @model.id

    { title, body, icon, tag }

  clickHandler: (event) ->
    data = @model.get('data')
    @model.markRead()
    event.target.close()

    url = @model.getUrlOfTarget()

    newTab = window.open(url)
    # Electron window.open doesn't return correctly even though window.open
    # succeeds so this keeps us from navigating and opening a new window
    if !isDesktop()
      if newTab?
        newTab.focus()
      else
        window.location.assign(url)

  localNotification: ->
    data = @model.get('data')
    _.any _.invoke [
      -> currentModelManager.onBoardView(data.board?.id)
      -> currentModelManager.onOrganizationView(data.organization?.id)
    ], 'call'

  # Try to get a lock for displaying the notification to prevent multiple tabs
  # from displaying the same one, and call the callback if successful.
  getLock: (next) ->
    key = "notification_lock_#{ @model.id }"

    # Check if another tab is displaying this notification.
    return if Storage.get(key)

    # We may be competing with other tabs for this write, so each tab will
    # attempt to write with a unique key, wait a small delay for contention,
    # and then try to read to see if it obtained the lock or not.
    uniqueValue = Math.random()
    Storage.set(key, uniqueValue)

    # Check if we obtained the lock and call the callback only if we did.
    setTimeout =>
      next() if Storage.get(key) == uniqueValue
    , LOCK_DELAY

    # Clean up our key after a small delay.
    setTimeout =>
      Storage.unset(key)
    , CLEAR_DELAY
